let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ciy0N")).then(() => parcelRequire('2izzE'));